import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { Backdrop, Character, Location, ScriptService } from '../../../../service/script.service';

export interface CharacterDialogData {
  character?: Character;
  isEdit: boolean;
  backdrop?: Backdrop | null;
}

export interface CharacterDialogResult {
  character: Character;
  delete?: boolean;
}

@Component({
  selector: 'app-character-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatButtonModule
  ],
  templateUrl: './character-dialog.component.html',
  styleUrl: './character-dialog.component.less'
})
export class CharacterDialogComponent {
  form: FormGroup;
  isEdit: boolean;
  availableLocations: Location[] = [];

  constructor(
    private fb: FormBuilder,
    private scriptService: ScriptService,
    public dialogRef: MatDialogRef<CharacterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CharacterDialogData
  ) {
    this.isEdit = data.isEdit;
    this.form = this.fb.group({
      tag: [data.character?.tag || '', [Validators.required, Validators.minLength(1)]],
      name: [data.character?.name || '', [Validators.required, Validators.minLength(1)]],
      location: [data.character?.location || null, Validators.required]
    });

    // Compute available locations based on backdrop + universal
    const universal = this.scriptService.universal_locations || [];
    const backdropLocations = data.backdrop?.locations || [];
    this.availableLocations = [...universal, ...backdropLocations];
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onTagInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    
    // Remove colon characters
    value = value.replace(/:/g, '');
    
    const upperCaseValue = value.toUpperCase();
    this.form.get('tag')?.setValue(upperCaseValue, { emitEvent: false });
  }

  onNameInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    
    // Remove colon characters
    value = value.replace(/:/g, '');
    
    this.form.get('name')?.setValue(value, { emitEvent: false });
  }

  onSave(): void {
    if (this.form.valid) {
      const result: CharacterDialogResult = {
        character: {
          tag: this.form.get('tag')?.value.trim(),
          name: this.form.get('name')?.value.trim(),
          location: this.form.get('location')?.value
        }
      };
      this.dialogRef.close(result);
    }
  }

  onDelete(): void {
    if (this.data.character) {
      const result: CharacterDialogResult = {
        character: this.data.character,
        delete: true
      };
      this.dialogRef.close(result);
    }
  }

  placeholder: {
    tag: string,
    name: string
  } = {
    tag: 'Enter character tag',
    name: 'Enter character name'
  };

  ngOnInit(): void {
    let placeholders = [
      {
        tag: 'DOCTOR',
        name: 'Doctor Bob'
      },
      {
        tag: 'OWNER',
        name: 'Cat Owner'
      },
      {
        tag: 'MARCO',
        name: 'Marco, a mobster'
      },
      {
        tag: "PALADIN",
        name: 'Paladin of Justice'
      },
      {
        tag: "HOST",
        name: 'Gameshow host'
      },
      {
        tag: "LUCKY",
        name: 'Lucky the cowboy'
      },
      {
        tag: "OPERATOR",
        name: "Radio operator"
      },
      {
        tag: "SISTER",
        name: "Sister of the bride"
      },
      {
        tag: "GROOM",
        name: "Groom"
      }
    ]
    this.placeholder = placeholders[Math.floor(Math.random() * placeholders.length)];
  }
}
